import React from 'react'

const Partner = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_19591)">
        <path
          d="M13.4503 3H10.2803C8.66035 3 7.36035 4.30998 7.36035 5.91998V18.09C7.36035 19.7 8.66035 21.01 10.2803 21.01H13.4503C15.0703 21.01 16.3703 19.7 16.3703 18.09V5.91998C16.3703 4.30998 15.0703 3 13.4503 3Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M3 20C3.47 19.99 3.91999 19.79 4.25999 19.46C4.59999 19.12 4.8 18.67 4.8 18.2V5.79999C4.8 5.32999 4.59999 4.87998 4.25999 4.53998C3.92999 4.19998 3.48 4.01 3 4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M21.0002 4C20.5202 4 20.0602 4.19002 19.7102 4.52002C19.3702 4.86002 19.1702 5.30999 19.1602 5.79999V18.21C19.1602 18.69 19.3702 19.15 19.7102 19.49C20.0602 19.83 20.5202 20.01 21.0002 20.01"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_19591">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Partner